module.exports = __webpack_public_path__ + "img/page-08.711e4bd3.jpg";